import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { Card } from "primereact/card";
import { Generico } from "../../components/Generico";
import { Proceso } from "../../models/cliente/Proceso";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";

export const Reprocesos = ({generic, permss, id}) => {

    const omodel = new Proceso(false);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors } } = useForm({ defaultValues });
    const [registers, setRegisters] = useState(null);
    const procesoSrv = new MonitoreoService()
    const { accionesTbl } = Generico();
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers, omodel, generic, errors, control, permss });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.proceso = id;
        procesoSrv.listado('admin-reproceso-cliente/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {table({ action01: accionesTbl })}
            </Card>
        </>
    )
}
